module.exports = __webpack_public_path__ + "img/desktop-3.96408642.png";